<template>
  <div class="home admin-home ccd-home">
    <header class="home-header admin-header">
      <div class="header-wrap">
        <router-link to="/">
          <img
            class="logo"
            src="./../assets/header/logo.png"
            alt="沐桦科技"
          />
        </router-link>
        <div class="email">{{email}}</div>
        <div
          class="quit"
          @click="logout"
        >退出</div>
      </div>
    </header>
    <section class="content">
      <!-- <el-col
        :span="4"
        class="left-menu"
      > -->
      <div class="left-menu">
        <div class="left-content">
          <div class="menu-wrap">
            <div class="title">泛载雾计算</div>
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              background-color="#243032"
              text-color="#fff"
              active-text-color="#00AEEF"
              router="router"
              :default-openeds="defaultOption"
            >
              <el-submenu
                index="1"
                route="/admin"
              >
                <template slot="title">
                  <span>高质量动态代理</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    route="/admin"
                    v-bind:class="{ isActive: (thisPath === '/admin') }"
                  >数据概览</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <el-submenu
                index="2"
                route="/ccd"
              >
                <template slot="title">
                  <span>CCD</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    route="/ccd"
                    v-bind:class="{ isActive: (thisPath === '/ccd') }"
                  >数据概览</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
              <!-- <el-submenu index="2">
                <template slot="title">
                  <span>边缘计算</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="2-1">PCDN</el-menu-item>
                </el-menu-item-group>
              </el-submenu> -->
              <el-menu-item
                index="3"
                disabled
              >
                <span slot="title">分布式存储</span>
              </el-menu-item>
              <el-menu-item
                index="3"
                disabled
              >
                <span slot="title">数据通道</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>
      <div class="right-content admin-right-wrap">
        <div class="service-choose">
          <h1 class="title">CDD - 数据概览</h1>
        </div>
        <div class="times"><i class="el-icon-warning"></i> 更新频率： 1次/日</div>
        <div class="service-wrap common-wrap ccd-service-wrap">
          <h1 class="title">我的服务</h1>
          <div class="secret-Detail">
            <div class="serviceDetail">
              <div class="service-title">当前节点总数</div>
              <div class="service-content">
                <span
                  v-if="host_num || host_num === 0"
                  class="service-big-content"
                >{{host_num}}</span>
                <span
                  v-if="!host_num && host_num !== 0"
                  class="service-big-content"
                >-</span>
                <div
                  v-if="last_host_num"
                  class="service-title"
                >昨天节点数量： {{last_host_num}}个</div>
              </div>
            </div>
            <div class="serviceDetail">
              <div class="service-title">当前实例总数</div>
              <div
                v-if="docker_num || docker_num === 0"
                class="service-content"
              ><span class="service-big-content">{{docker_num}}</span></div>
              <div
                v-if="!docker_num  && docker_num !== 0"
                class="service-content"
              ><span class="service-big-content">-</span></div>
              <div
                v-if="last_host_num"
                class="service-title"
              >当前实例数量： {{last_docker_num}}个</div>
            </div>
            <div class="serviceDetail">
              <div class="service-title">昨日总带宽</div>
              <div
                class="service-content"
                v-if="bandWidth || bandWidth === 0"
              >
                <span class="service-big-content">{{bandWidth}}</span>
                Gbps</div>
              <div
                class="service-big-content"
                v-if="!bandWidth && bandWidth !== 0"
              >-</div>
              <div class="service-title">详见下方带宽详情</div>
            </div>
          </div>
        </div>

        <div class="common-wrap bandwidth-wrap">
          <h1 class="title">历史带宽详情</h1>
          <div class="">
            <span class="demonstration">日期</span>
            <el-date-picker
              v-model="selectDate"
              type="date"
              size="smail"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div
              class="button search-button bonus-cursor"
              v-on:click="searchLogs"
            >查询</div>
          </div>
          <div class="log-detail">
            <ve-line
              v-loading="!(serviceRate.rows && serviceRate.rows.length)"
              v-if="serviceRate !== '暂无数据'"
              :data="serviceRate"
              :settings="chartSetting"
            ></ve-line>
            <div v-if="serviceRate === '暂无数据'">暂无数据</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import moment from "moment";

export default {
  name: "home",
  components: {
    Footer,
    Menu
  },
  data() {
    return {
      host_num: "",
      docker_num: "",
      last_host_num: "",
      last_docker_num: "",
      bandWidth: "",
      selectDate: moment()
        .utc()
        .startOf("day"),
      chartSetting: {
        yAxisName: ["单位：Gbps"],
        area: true
      },
      serviceRate: [],
      loading: true
    };
  },
  computed: mapState({
    key: state => state.user.key,
    secret: state => state.user.secret,
    service: state => state.service,
    lineCount: state => state.service.lineCount,
    ports: state => state.service.ports,
    email: state => state.user.email,
    thisPath() {
      return this.$route.path;
    },
    defaultOption() {
      return ["2"];
    }
  }),

  created() {
    let that = this;
    let { selectDate } = this;
    selectDate = moment(selectDate).format("YYYY-MM-DD");

    // 获取用户信息
    this.getUserInfo();

    // 获取service日志
    this.getCCDInfo().then(data => {
      this.host_num = data.host_num;
      this.docker_num = data.docker_num;
      this.last_host_num = data.last_host_num;
      this.last_docker_num = data.last_docker_num;
      this.bandWidth = data.bandWidth;
    });

      this.dealData(selectDate);

  },
  methods: {
    ...mapActions([
      "getUserInfo",
      "logout",
      "getCCDInfo",
      "getBandwidthDetail"
    ]),
    // 日志查询
    searchLogs() {
      let { selectDate } = this;
      let that = this;
      selectDate = moment(selectDate).format("YYYY-MM-DD");
      this.serviceRate = "loading";

      this.dealData(selectDate);
    },

    dealData(selectDate) {
      let that = this;
      // 获取service日志
      // 获取service日志
      this.getBandwidthDetail({ selectDate }).then(res => {
        if (res) {
          // 此处为了中英文对照，所以动态处理
          let useBandCharts = {
            columns: ["日期", "移动", "联通", "电信"],
            rows: []
          };

          let { cm, ct, cu } = res;
          // let {cm, ct, cu} = res;
          let dealData = {};
          let useBandData = [];

          cm.map(item => {
            let date_at = moment(item.time).format("YYYY-MM-DD HH:mm:ss");
            if (dealData[date_at]) {
              dealData[date_at]["移动"] = item.out_bps / 1000000000;
            } else {
              dealData[date_at] = {
                date_at: item.time,
                日期: date_at,
                移动: item.out_bps / 1000000000
              };
            }
          });

          ct.map(item => {
            let date_at = moment(item.time).format("YYYY-MM-DD HH:mm:ss");
            if (dealData[date_at]) {
              dealData[date_at]["电信"] = item.out_bps / 1000000000;
            } else {
              dealData[date_at] = {
                date_at: item.time,
                日期: date_at,
                电信: item.out_bps / 1000000000
              };
            }
          });

          cu.map(item => {
            let date_at = moment(item.time).format("YYYY-MM-DD HH:mm:ss");
            if (dealData[date_at]) {
              dealData[date_at]["联通"] = item.out_bps / 1000000000;
            } else {
              dealData[date_at] = {
                date_at: item.time,
                日期: date_at,
                联通: item.out_bps / 1000000000
              };
            }
          });

          Object.keys(dealData).forEach(v => {
            let o = {};
            o = dealData[v];
            o[v] = v;
            useBandData.push(o);
          });

          function compare(data) {
            return function(obj1, obj2) {
              var value1 = obj1[data];
              var value2 = obj2[data];
              return value1 - value2; // 升序
            };
          }
          useBandData = useBandData.sort(compare("date_at"));

          useBandCharts.rows = useBandData;
          that.serviceRate = useBandCharts;
        } else {
          that.serviceRate = "暂无数据";
        }
      });
    }
  }
};
</script>

<style lang="stylus">
.content {
  .ccd-service-wrap {
    .secret-Detail {
      .serviceDetail {
        width: 33.33% !important;
      }
    }
  }

  .times {
    margin-bottom: 30px;
  }
}

.search-button {
  margin: 0 20px 20px;
}

.bandwidth-wrap {
  margin-bottom: 50px;
}
</style>




